import React from 'react';
import {Youtube} from 'lucide-react';
import { Container, Row, Col, Card, Button, Carousel, Spinner } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Footer = () => {
    return (
        <>
        <footer className="bg-dark text-white py-5 mt-auto">
            <Container fluid>
                <div className="d-flex flex-column align-items-center text-center">
                    <section className="mb-3">
                        <Link to="/">
                            <img
                                src="/static/Best-logo.webp" // or import logo from assets
                                alt="Logo"
                                width="75"
                                height="75"
                                className="d-inline-block align-top me-2"
                            />
                        </Link>
                    </section>
                    <section className="mb-3">
                        <Link to="https://www.youtube.com/@b.e.s.tinstituteresearchce103" className="text-light text-decoration-none">
                            <Youtube size={24} className="me-2" />
                        </Link>
                    </section>
                    <section className="mb-3">
                        <Link to="/" className="text-light text-decoration-none me-3">Home</Link>
                        <Link to="/about" className="text-light text-decoration-none me-3">About Us</Link>
                        <Link to="/contacts" className="text-light text-decoration-none">Contacts</Link>
                    </section>
                    <section>
                        <p className="mb-0">&copy; {new Date().getFullYear()} BEST Institute & Research Centre. All Rights Reserved.</p>
                    </section>
                </div>
            </Container>
        </footer>
                  
        </>
    );
};

export default Footer;